import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Button } from "~/shared/ui-kit";
import { Container } from "~/shared/ui-kit/container/Container";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Title } from "~/shared/ui-kit/title/Title";

import type { CardGalleryProps } from "../CardGallery";
import { ColumnCard } from "./ColumnCard";

export const Column: FC<CardGalleryProps> = (props) => {
  const { data, getUrl, isControlInactive, onCallAction } = props;
  const controlAction = data?.action;
  const action = data.action?.action?.[0];
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (action) {
      onCallAction(action);
    }
  };
  return (
    <Container
      as="section"
      className="max-w-[1240px] mx-auto py-8 lg:py-16"
      flexDirection="column"
    >
      <Title
        as="h2"
        size="medium"
        weight="semibold"
        className="text-center mb-8 lg:mb-16"
      >
        {data.title}
      </Title>
      <Flex
        flexDirection="column"
        gap={24}
        justify="center"
        align="center"
        d={{ gap: 20 }}
      >
        {data?.cards?.map(
          (card) => card && <ColumnCard key={card.id} {...props} card={card} />,
        )}
      </Flex>

      {!isInactive && (
        <Flex align="center" justify="center" className=" mt-6 md:mt-12">
          <Button
            onPress={handlePressButton}
            href={href}
            size="small"
            weight="bold"
            className="lg:py-4 lg:px-12 py-3 px-6 text-nowrap "
          >
            {data.action_text}
          </Button>
        </Flex>
      )}
    </Container>
  );
};
